import NewTaskScreen from './NewTaskScreen';

export default NewTaskScreen;
